var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "431A8AAC-FF3A-4AA6-81E3-58ACF26495E7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1660,
    height: 1010
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 1100,
    height: 990
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 1100,
    height: 260
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8288777,8.11857422 L21.718042,0.176835937 C21.6025718,0.0638671875 21.4432639,0 21.2768674,0 L9.18824695,0 C7.83537356,0 6.73470657,1.03675781 6.73470657,2.31105469 L6.73470657,10.3846289 L1.83564716,10.3846289 C0.823463817,10.3846289 0,11.1603516 0,12.1139062 L0,20.7707812 C0,21.7242773 0.823463817,22.5 1.83564716,22.5 L6.73470657,22.5 L6.73470657,27.6929883 C6.73470657,28.9650586 7.83537356,30 9.18824695,30 L27.5464596,30 C28.899333,30 30,28.9656445 30,27.6942773 L30,8.51865234 C30,8.36947266 29.9386273,8.22609375 29.8288777,8.11857422 Z M21.4285892,1.55748047 L28.0868752,8.07691406 L21.4285892,8.07691406 L21.4285892,1.55748047 Z M28.7754683,27.6942773 C28.7754683,28.3294336 28.2241088,28.8461719 27.5463974,28.8461719 L9.18824695,28.8461719 C8.51053554,28.8461719 7.95917606,28.3289063 7.95917606,27.6930469 L7.95917606,22.5 L18.3684725,22.5 C19.3806559,22.5 20.2041197,21.7242773 20.2041197,20.7707813 L20.2041197,12.1139063 C20.2041197,11.1603516 19.3806559,10.3846289 18.3684725,10.3846289 L7.95917606,10.3846289 L7.95917606,2.31105469 C7.95917606,1.67291016 8.51053554,1.15382813 9.18824695,1.15382813 L20.2040575,1.15382813 L20.2040575,8.65382813 C20.2040575,8.97246094 20.4782138,9.23074219 20.8162923,9.23074219 L28.7754683,9.23074219 L28.7754683,27.6942773 Z M2.5,19.4516212 L4.47554876,16.646996 L2.58752431,13.7577318 L4.08377327,13.7577318 L5.33828841,15.6736487 L6.69699917,13.7577318 L7.73478744,13.7577318 L5.84259517,16.4430932 L7.80147263,19.4516212 L6.3093915,19.4516212 L4.97151987,17.4164405 L3.53778827,19.4516212 L2.5,19.4516212 Z M8.76007224,19.4516212 L8.76007224,13.7577318 L10.0437622,13.7577318 L10.0437622,18.6437044 L12.823701,18.6437044 L12.823701,19.4516212 L8.76007224,19.4516212 Z M13.3780217,19.4016073 L13.3780217,18.4244128 C14.0420983,18.6808955 14.6103061,18.809135 15.0826619,18.809135 C15.4133109,18.809135 15.6737973,18.7411681 15.8641289,18.6052322 C16.0544605,18.4692963 16.1496249,18.2846315 16.1496249,18.0512322 C16.1496249,17.8665646 16.0898867,17.7107536 15.9704084,17.5837946 C15.8509302,17.4568357 15.6244807,17.3061543 15.2910531,17.131746 L14.8784385,16.9201488 C14.3255043,16.632888 13.935122,16.3578144 13.7072798,16.0949195 C13.4794376,15.8320247 13.3655182,15.5248911 13.3655182,15.1735097 C13.3655182,14.7041462 13.5523738,14.3271222 13.9260906,14.0424263 C14.2998074,13.7577304 14.7936896,13.6153846 15.4077522,13.6153846 C15.8995579,13.6153846 16.453873,13.6807867 17.0707141,13.811593 L17.0707141,14.7233847 C16.4399802,14.5053743 15.9412355,14.3963708 15.5744651,14.3963708 C15.2910517,14.3963708 15.0639075,14.4547197 14.8930258,14.5714194 C14.7221442,14.6881191 14.6367046,14.8413652 14.6367046,15.0311625 C14.6367046,15.187617 14.6964429,15.3248332 14.8159211,15.4428153 C14.9353993,15.5607974 15.1604596,15.705708 15.4911086,15.8775515 L15.932898,16.1045376 C16.5275106,16.4123169 16.9373426,16.6957262 17.1624062,16.9547738 C17.3874699,17.2138214 17.5,17.5292905 17.5,17.9011905 C17.5,18.429545 17.2874431,18.8437585 16.8623229,19.1438434 C16.4372027,19.4439282 15.8509346,19.5939684 15.103501,19.5939684 C14.6089167,19.5939684 14.0337627,19.5298487 13.3780217,19.4016073 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Furniture-/-3.1_Factory_Profile_01",
    transform: "translate(-270.000000, -1485.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper",
    fill: "#F6F7FA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1920,
    height: 1660
  })), /*#__PURE__*/React.createElement("g", {
    id: "Conteainer",
    transform: "translate(220.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Block_Left",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 640.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Bound",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 520,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_pdf",
    transform: "translate(10.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_file_xls"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-8)",
    fill: "#1A7954"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Color",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.90904a34f4048dcb3455c971d22ba6c8.svg";
export { ForwardRef as ReactComponent };